/**
 * Formats a Date object or string to the standard string format used by the backend
 * Returns format like: "Mon Jul 14 2025 15:21:30 GMT+1000"
 */
export const formatDateForBackend = (date: Date | string): string => {
    if (date instanceof Date) {
        return date.toString(); // Returns "Mon Jul 14 2025 15:21:30 GMT+1000" format
    } else if (typeof date === 'string') {
        // If it's already a string, convert it to a Date first, then to string
        return new Date(date).toString();
    }
    // Fallback for any other type
    return String(date);
};

/**
 * Formats a Date object to ISO string format
 * Returns format like: "2025-07-14T05:21:30.000Z"
 */
export const formatDateToISO = (date: Date): string => {
    return date.toISOString();
};

/**
 * Formats a Date object to a simple date string (YYYY-MM-DD)
 * Returns format like: "2025-07-14"
 */
export const formatDateToSimple = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}; 